import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 15000 });

// Inject auth token
client.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public
export const getProjects = () => client.get('/projects').then(r => r.data);
export const getSkills = () => client.get('/skills').then(r => r.data);
export const getCertifications = () => client.get('/certifications').then(r => r.data);
export const submitContact = (data) => client.post('/contact', data).then(r => r.data);

// Auth
export const login = (email, password) => client.post('/auth/login', { email, password }).then(r => r.data);
export const getMe = () => client.get('/auth/me').then(r => r.data);

// Admin — Projects
export const adminCreateProject = (data) => client.post('/admin/projects', data).then(r => r.data);
export const adminUpdateProject = (id, data) => client.put(`/admin/projects/${id}`, data).then(r => r.data);
export const adminDeleteProject = (id) => client.delete(`/admin/projects/${id}`).then(r => r.data);

// Admin — Skills
export const adminCreateSkill = (data) => client.post('/admin/skills', data).then(r => r.data);
export const adminUpdateSkill = (id, data) => client.put(`/admin/skills/${id}`, data).then(r => r.data);
export const adminDeleteSkill = (id) => client.delete(`/admin/skills/${id}`).then(r => r.data);

// Admin — Certifications
export const adminCreateCert = (data) => client.post('/admin/certifications', data).then(r => r.data);
export const adminUpdateCert = (id, data) => client.put(`/admin/certifications/${id}`, data).then(r => r.data);
export const adminDeleteCert = (id) => client.delete(`/admin/certifications/${id}`).then(r => r.data);

// Admin — Messages
export const adminGetMessages = () => client.get('/admin/messages').then(r => r.data);
export const adminMarkRead = (id) => client.patch(`/admin/messages/${id}/read`).then(r => r.data);
export const adminDeleteMessage = (id) => client.delete(`/admin/messages/${id}`).then(r => r.data);

// Admin — Settings
export const adminSaveSetting = (key, value) => client.put(`/admin/settings/${key}`, { key_name: key, value }).then(r => r.data);
export const adminGetSetting = (key) => client.get(`/settings/${key}`).then(r => r.data).catch(() => null);

// Admin — Stats
export const adminGetStats = () => client.get('/admin/stats').then(r => r.data);

// Admin — Seed
export const adminSeed = () => client.post('/admin/seed').then(r => r.data);

// Testimonials
export const getTestimonials = () => client.get('/testimonials').then(r => r.data);
export const adminGetTestimonials = () => client.get('/admin/testimonials').then(r => r.data);
export const adminCreateTestimonial = (data) => client.post('/admin/testimonials', data).then(r => r.data);
export const adminUpdateTestimonial = (id, data) => client.put(`/admin/testimonials/${id}`, data).then(r => r.data);
export const adminDeleteTestimonial = (id) => client.delete(`/admin/testimonials/${id}`).then(r => r.data);

// Blog Posts
export const getPosts = () => client.get('/posts').then(r => r.data);
export const getPost = (slug) => client.get(`/posts/${slug}`).then(r => r.data);
export const adminGetPosts = () => client.get('/admin/posts').then(r => r.data);
export const adminCreatePost = (data) => client.post('/admin/posts', data).then(r => r.data);
export const adminUpdatePost = (id, data) => client.put(`/admin/posts/${id}`, data).then(r => r.data);
export const adminDeletePost = (id) => client.delete(`/admin/posts/${id}`).then(r => r.data);

// Services
export const getServices = () => client.get('/services').then(r => r.data);
export const adminGetServices = () => client.get('/admin/services').then(r => r.data);
export const adminCreateService = (data) => client.post('/admin/services', data).then(r => r.data);
export const adminUpdateService = (id, data) => client.put(`/admin/services/${id}`, data).then(r => r.data);
export const adminDeleteService = (id) => client.delete(`/admin/services/${id}`).then(r => r.data);

// Gallery
export const getGallery = () => client.get('/gallery').then(r => r.data);
export const adminGetGallery = () => client.get('/admin/gallery').then(r => r.data);
export const adminCreateGallery = (data) => client.post('/admin/gallery', data).then(r => r.data);
export const adminUpdateGallery = (id, data) => client.put(`/admin/gallery/${id}`, data).then(r => r.data);
export const adminDeleteGallery = (id) => client.delete(`/admin/gallery/${id}`).then(r => r.data);

export default client;
